(() => {
  const guideVariantId = 55102142480703;
  window.TrustTapGuideVariantId = guideVariantId;
  const jsonHeaders = {'Content-Type':'application/json', Accept:'application/json'};
  const localeRoot = window.Shopify?.routes?.root || '/';
  const cartPath = path => `${localeRoot.replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  const isEnglishRoute = /^\/en(?:\/|$)/.test(localeRoot);
  window.TrustTapCartPath = cartPath;

  async function loadCart() {
    const response = await fetch(cartPath('cart.js'), {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(isEnglishRoute ? 'Cart unavailable' : 'Panier indisponible');
    return response.json();
  }

  async function addGuide() {
    const response = await fetch(cartPath('cart/add.js'), {
      method:'POST', headers:jsonHeaders,
      body:JSON.stringify({items:[{id:guideVariantId,quantity:1,properties:{'_Guide TrustTap':'Offert avec la commande'}}]})
    });
    if (!response.ok) throw new Error(isEnglishRoute ? 'Guide unavailable' : 'Guide indisponible');
  }

  async function reconcileGuide(cart) {
    if (!cart) cart = await loadCart();
    const guide = cart.items.find(item => Number(item.variant_id) === guideVariantId);
    const otherItems = cart.items.filter(item => Number(item.variant_id) !== guideVariantId);
    if (otherItems.length && !guide) {
      await addGuide();
      return loadCart();
    }
    if (!otherItems.length && guide) {
      await fetch(cartPath('cart/change.js'), {method:'POST',headers:jsonHeaders,body:JSON.stringify({id:guide.key,quantity:0})});
      return loadCart();
    }
    if (guide?.quantity > 1) {
      await fetch(cartPath('cart/change.js'), {method:'POST',headers:jsonHeaders,body:JSON.stringify({id:guide.key,quantity:1})});
      return loadCart();
    }
    return cart;
  }

  window.TrustTapAddItems = async items => {
    const cart = await loadCart();
    const hasGuide = cart.items.some(item => Number(item.variant_id) === guideVariantId);
    const payload = [...items];
    if (!hasGuide) payload.push({id:guideVariantId,quantity:1,properties:{'_Guide TrustTap':'Offert avec la commande'}});
    const response = await fetch(cartPath('cart/add.js'), {method:'POST',headers:jsonHeaders,body:JSON.stringify({items:payload})});
    if (!response.ok) throw new Error(isEnglishRoute ? 'Unable to add this product to your cart.' : 'Impossible d’ajouter ce produit au panier.');
    return reconcileGuide(await loadCart());
  };
  window.TrustTapEnsureGuide = () => reconcileGuide();
})();

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.trusttap-shared-header');
  if (!root || (root.dataset.ready === 'true' && window.TrustTapCart)) return;
  root.dataset.ready = 'true';
  const menuButton = root.querySelector('[data-site-menu-button]');
  const mobilePanel = root.querySelector('[data-site-mobile-panel]');
  const navigationHeader = root.querySelector('header');
  const announcement = root.querySelector('.announcement');
  let stickyThreshold = 0;
  let stickyFrame = 0;
  const measureStickyNavigation = () => {
    stickyThreshold = root.offsetTop + (announcement?.offsetHeight || 0);
    root.style.setProperty('--trusttap-fixed-nav-height', `${navigationHeader?.offsetHeight || 72}px`);
  };
  const updateStickyNavigation = () => {
    stickyFrame = 0;
    const shouldFix = window.scrollY > stickyThreshold;
    navigationHeader?.classList.toggle('is-scroll-fixed', shouldFix);
    root.classList.toggle('is-nav-fixed', shouldFix);
  };
  const requestStickyNavigation = () => {
    if (stickyFrame) return;
    stickyFrame = window.requestAnimationFrame(updateStickyNavigation);
  };
  measureStickyNavigation();
  updateStickyNavigation();
  window.addEventListener('scroll', requestStickyNavigation, {passive:true});
  window.addEventListener('resize', () => { measureStickyNavigation(); requestStickyNavigation(); });
  menuButton?.addEventListener('click', () => {
    const open = mobilePanel?.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  mobilePanel?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    mobilePanel.classList.remove('open'); menuButton?.setAttribute('aria-expanded', 'false');
  }));

  const drawer = root.querySelector('[data-site-cart-drawer]');
  const overlay = root.querySelector('[data-site-cart-overlay]');
  const itemsTarget = root.querySelector('[data-site-cart-items]');
  const footer = root.querySelector('[data-site-cart-footer]');
  const totalTarget = root.querySelector('[data-site-cart-total]');
  const countTarget = root.querySelector('[data-site-cart-count]');
  const progress = root.querySelector('[data-site-cart-progress]');
  const progressCopy = root.querySelector('[data-site-cart-progress-copy]');
  const progressFill = root.querySelector('[data-site-cart-progress-fill]');
  const shippingMilestone = root.querySelector('[data-site-shipping-milestone]');
  const upsells = root.querySelector('[data-site-cart-upsells]');
  const upgradeOffer = root.querySelector('[data-site-upgrade-offer]');
  const savingsRow = root.querySelector('[data-site-cart-savings-row]');
  const savingsTarget = root.querySelector('[data-site-cart-savings]');
  const shippingThreshold = Number(root.dataset.freeShippingThreshold) || 10000;
  const isEnglish = root.dataset.cartLocale === 'en';
  const cartMarket = root.dataset.cartMarket || 'quebec';
  const googleOneId = Number(root.dataset.googleOneId) || 0;
  const googleTwoId = Number(root.dataset.googleTwoId) || 0;
  const googleFiveId = Number(root.dataset.googleFiveId) || 0;
  const standId = Number(root.dataset.standId) || 0;
  const socialId = Number(root.dataset.socialId) || 0;
  const comparePrices = {
    [googleOneId]: Number(root.dataset.googleOneCompare) || 0,
    [googleTwoId]: Number(root.dataset.googleTwoCompare) || 0,
    [googleFiveId]: Number(root.dataset.googleFiveCompare) || 0,
    [standId]: Number(root.dataset.standCompare) || 0,
    [socialId]: Number(root.dataset.socialCompare) || 0
  };
  const money = value => new Intl.NumberFormat(isEnglish ? 'en-CA' : 'fr-CA', {style:'currency',currency:window.Shopify?.currency?.active || 'CAD'}).format(value / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'})[character]);
  const compareLinePrice = item => Math.max(item.original_line_price || 0, (comparePrices[Number(item.variant_id)] || 0) * item.quantity);
  const translatedProductTitle = item => {
    if (!isEnglish) return item.product_title;
    const variantId = Number(item.variant_id);
    if (variantId === window.TrustTapGuideVariantId) return 'TrustTap Guide — Improve Your Local Visibility on Google';
    if ([googleOneId, googleTwoId, googleFiveId].includes(variantId)) return 'Google Review NFC Plate — TrustTap';
    if (variantId === standId) return 'TrustTap Plate Stand';
    if (variantId === socialId) return 'Instagram + Facebook Pack (Meta Business) — TrustTap';
    return item.product_title;
  };
  const translatedVariantTitle = value => {
    if (!isEnglish) return value;
    return ({'1 plaquette':'1 plate','2 plaquettes':'2 plates','5 plaquettes':'5 plates','Guide PDF':'PDF guide'})[value] || value;
  };
  const translatedProperty = (key, value) => {
    if (!isEnglish) return [key, value];
    const translatedKey = ({'Offre TrustTap':'TrustTap offer','Langue imprimée':'Printed language'})[key] || key;
    const translatedValue = ({'Prix promotionnel déjà appliqué':'Promotional price already applied','Français':'French'})[value] || value;
    return [translatedKey, translatedValue];
  };

  function updateCartBenefits(cart) {
    const paidItems = cart.items.filter(item => Number(item.variant_id) !== window.TrustTapGuideVariantId);
    const hasPaidItems = paidItems.length > 0;
    const remaining = Math.max(0, shippingThreshold - cart.total_price);
    if (progress) progress.hidden = !hasPaidItems;
    if (hasPaidItems && progressCopy) {
      const destination = cartMarket === 'us' ? 'the United States' : 'Canada';
      const destinationFr = cartMarket === 'france' ? 'la France' : 'le Canada';
      progressCopy.textContent = remaining > 0
        ? (isEnglish ? `${money(remaining)} away from free shipping to ${destination}` : `Plus que ${money(remaining)} avant la livraison gratuite vers ${destinationFr}`)
        : (isEnglish ? `Free shipping to ${destination} unlocked ✓` : `Livraison gratuite vers ${destinationFr} débloquée ✓`);
    }
    if (progressFill) progressFill.style.width = `${Math.min(100, (cart.total_price / shippingThreshold) * 100)}%`;
    if (shippingMilestone) shippingMilestone.classList.toggle('is-unlocked', remaining === 0);

    const totalSavings = paidItems.reduce((sum, item) => sum + Math.max(0, compareLinePrice(item) - item.final_line_price), 0);
    if (savingsRow) savingsRow.hidden = !hasPaidItems || totalSavings <= 0;
    if (savingsTarget) savingsTarget.textContent = money(totalSavings);

    const hasOnePlaque = paidItems.some(item => Number(item.variant_id) === googleOneId && item.quantity === 1);
    const hasLargerPlaquePack = paidItems.some(item => [googleTwoId, googleFiveId].includes(Number(item.variant_id)));
    if (upgradeOffer) {
      upgradeOffer.hidden = !hasOnePlaque || hasLargerPlaquePack;
      if (!upgradeOffer.hidden) {
        const upgradeButton = upgradeOffer.querySelector('[data-site-cart-upgrade]');
        if (upgradeButton && !upgradeButton.disabled) upgradeButton.textContent = isEnglish ? 'Choose' : 'Choisir';
      }
    }
    root.querySelectorAll('[data-site-add-offer]').forEach(offer => {
      const exists = paidItems.some(item => Number(item.variant_id) === Number(offer.dataset.variantId));
      offer.hidden = exists;
      if (!exists) {
        const addButton = offer.querySelector('[data-site-cart-add]');
        if (addButton && !addButton.disabled) addButton.textContent = isEnglish ? 'Add' : 'Ajouter';
      }
    });
    if (upsells) {
      const visibleOffers = Array.from(upsells.querySelectorAll('.trusttap-cart-upsell')).filter(offer => !offer.hidden);
      visibleOffers.forEach((offer, index) => { offer.hidden = index >= 2; });
      upsells.hidden = !hasPaidItems || visibleOffers.length === 0;
    }
  }

  async function refreshCart() {
    const cart = await window.TrustTapEnsureGuide();
    itemsTarget.innerHTML = cart.items.length ? cart.items.map(item => {
      const properties = Object.entries(item.properties || {}).filter(([key,value]) => key.charAt(0) !== '_' && value).map(([key,value]) => { const translated = translatedProperty(key, value); return `<small><b>${escapeHtml(translated[0])}:</b> ${escapeHtml(translated[1])}</small>`; }).join('');
      const isGuide = Number(item.variant_id) === window.TrustTapGuideVariantId;
      const referencePrice = compareLinePrice(item);
      const price = referencePrice > item.final_line_price ? `<span><del>${money(referencePrice)}</del> ${money(item.final_line_price)}</span>` : `<span>${money(item.final_line_price)}</span>`;
      const controls = isGuide ? `<small><b>${isEnglish ? 'Included free with your order' : 'Inclus gratuitement avec votre commande'}</b></small>` : `<div class="trusttap-cart-controls"><button type="button" data-site-cart-key="${escapeHtml(item.key)}" data-site-cart-quantity="${Math.max(0,item.quantity-1)}" aria-label="${isEnglish ? 'Decrease quantity' : 'Diminuer'}">&minus;</button><b>${item.quantity}</b><button type="button" data-site-cart-key="${escapeHtml(item.key)}" data-site-cart-quantity="${item.quantity+1}" aria-label="${isEnglish ? 'Increase quantity' : 'Augmenter'}">+</button><button class="trusttap-cart-remove" type="button" data-site-cart-key="${escapeHtml(item.key)}" data-site-cart-quantity="0">${isEnglish ? 'Remove' : 'Retirer'}</button></div>`;
      const variantTitle = translatedVariantTitle(item.variant_title);
      return `<article class="trusttap-cart-line"><img src="${escapeHtml(item.image)}" alt=""><div><strong>${escapeHtml(translatedProductTitle(item))}</strong>${variantTitle ? `<small>${escapeHtml(variantTitle)}</small>` : ''}${properties}${price}${controls}</div></article>`;
    }).join('') : `<div class="trusttap-cart-empty"><strong>${isEnglish ? 'Your cart is empty.' : 'Votre panier est vide.'}</strong><a href="${escapeHtml((window.Shopify?.routes?.root || '/') + 'collections/all')}">${isEnglish ? 'Explore our products' : 'D&eacute;couvrir nos produits'} &rarr;</a></div>`;
    totalTarget.textContent = money(cart.total_price); footer.hidden = !cart.items.length;
    updateCartBenefits(cart);
    const visibleItemCount = cart.items.filter(item => Number(item.variant_id) !== window.TrustTapGuideVariantId).reduce((sum,item) => sum + item.quantity, 0);
    if (countTarget) { countTarget.textContent = visibleItemCount; countTarget.hidden = visibleItemCount === 0; }
    root.querySelector('[data-site-cart-open]')?.setAttribute('aria-label', isEnglish ? `Cart, ${visibleItemCount} item${visibleItemCount === 1 ? '' : 's'}` : `Panier, ${visibleItemCount} article${visibleItemCount === 1 ? '' : 's'}`);
  }
  async function openCart() { await refreshCart(); drawer.classList.add('is-open'); overlay.hidden = false; drawer.setAttribute('aria-hidden','false'); document.body.classList.add('trusttap-cart-open'); }
  window.TrustTapCart = { open: openCart, refresh: refreshCart };
  function closeCart() { drawer.classList.remove('is-open'); overlay.hidden = true; drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('trusttap-cart-open'); }
  root.querySelector('[data-site-cart-open]')?.addEventListener('click', () => openCart().catch(() => {}));
  root.querySelector('[data-site-cart-close]')?.addEventListener('click', closeCart); overlay?.addEventListener('click', closeCart);
  drawer?.addEventListener('click', async event => {
    const control = event.target.closest('[data-site-cart-key]'); if (!control) return;
    control.disabled = true;
    try { await fetch(window.TrustTapCartPath('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:control.dataset.siteCartKey,quantity:Number(control.dataset.siteCartQuantity)})}); await refreshCart(); }
    finally { control.disabled = false; }
  });

  root.querySelectorAll('[data-site-cart-add]').forEach(button => button.addEventListener('click', async () => {
    const offer = button.closest('[data-site-add-offer]');
    const variantId = Number(offer?.dataset.variantId);
    if (!variantId || button.disabled) return;
    const previous = button.textContent;
    button.disabled = true;
    button.textContent = isEnglish ? 'Adding…' : 'Ajout…';
    try {
      await window.TrustTapAddItems([{id:variantId,quantity:1}]);
      await refreshCart();
    } catch (error) {
      button.textContent = previous;
      window.alert(error.message || (isEnglish ? 'Unable to add this product.' : 'Impossible d’ajouter ce produit.'));
    } finally { button.disabled = false; }
  }));

  root.querySelector('[data-site-cart-upgrade]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    if (!googleOneId || !googleTwoId || button.disabled) return;
    const previous = button.textContent;
    button.disabled = true;
    button.textContent = isEnglish ? 'Adding…' : 'Ajout…';
    try {
      const cart = await window.TrustTapEnsureGuide();
      const onePlaque = cart.items.find(item => Number(item.variant_id) === googleOneId && item.quantity === 1);
      if (!onePlaque) { await refreshCart(); return; }
      await window.TrustTapAddItems([{id:googleTwoId,quantity:1,properties:onePlaque.properties || {}}]);
      const response = await fetch(window.TrustTapCartPath('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:onePlaque.key,quantity:0})});
      if (!response.ok) throw new Error(isEnglish ? 'Unable to replace the plate with the pack.' : 'Impossible de remplacer la plaque par le pack.');
      await refreshCart();
    } catch (error) {
      button.textContent = previous;
      window.alert(error.message || (isEnglish ? 'Unable to update the pack.' : 'Impossible de modifier le pack.'));
    } finally { button.disabled = false; }
  });

  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeCart(); mobilePanel?.classList.remove('open'); } });
});
